import clsx from 'clsx';
import { Banner } from '../../../../banner/Banner';
import { RadioGroupComponent, RadioGroupProps } from '../../../../radio/RadioGroup';
import { RadioWrapper } from '../../../../radio/RadioWrapper';
import { ComingSoonChip } from '../../../../shared/components/ComingSoon/ComingSoonChip';
import { PipelineConfigModeOption } from '../../interfaces/pipeline-settings-form-state';
import { Chip } from '../../../../chip/Chip';

interface PipelineConfigRadioGroupWrapperProps extends Omit<RadioGroupProps, 'children'> {
  id?: string;
  configModes: PipelineConfigModeOption[];
  disabled?: boolean;
}

export function PipelineConfigRadioGroupWrapper({
  id = '',
  name,
  defaultValue,
  currentValue,
  row,
  onChange,
  configModes,
  disabled
}: PipelineConfigRadioGroupWrapperProps) {
  return (
    <RadioGroupComponent
      id={id}
      name={name}
      defaultValue={defaultValue}
      currentValue={currentValue}
      className='grid-column-span-1'
      row={row}
      onChange={onChange}
    >
      {configModes.map((mode, index) => (
        <RadioWrapper
          key={mode.id}
          dataId={`${id}-${mode.id}`}
          radioProps={{ value: mode.value }}
          label={
            <div className='center-flex-row'>
              {mode.label}
              {mode.isRecommended ? (
                <Chip
                  dataId={String(mode.value)}
                  label='Recommended'
                  withText
                  className='ml-2'
                  disabled={disabled}
                />
              ) : null}

              {mode.isComingSoon ? (
                <ComingSoonChip className='ml-2' withText disabled={disabled} />
              ) : null}
            </div>
          }
          disabled={disabled || mode.isComingSoon}
          className={clsx('grid-column-span-1', index > 0 && 'mt-5')}
        >
          <>
            {mode.description}
            {mode.banner ? (
              <Banner
                open
                dataId=''
                color={mode.banner.color}
                icon={mode.banner.icon}
                className={clsx('mt-3')}
              >
                <div className='text-body-2'>{mode.banner.title}</div>

                <div className='text-body-1'>{mode.banner.description}</div>
              </Banner>
            ) : null}
          </>
        </RadioWrapper>
      ))}
    </RadioGroupComponent>
  );
}
